import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import PaymentSuccess from "./PaymentSuccess";
import PaymentFeild from "./PaymentFeild";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function PaymentResponse() {
  const { RendomTokenfetch } = useAuth();
  const getLastSegment = () => {
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);
    return segments[segments.length - 1];
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [PaymetSuess, setPaymetSuess] = useState(false);
  const [PayFeild, setPayFeild] = useState(false);

  const [Paymentdata, setPaymentdata] = useState([]);
  // console.log(orderid);
  // console.log(Paymentdata);

  // useEffect(() => {
  //   setLoading(true);
  //   let fdata = new FormData();
  //   fdata.append("order_id", getLastSegment());
  //   const FetchVendorStatusData = async () => {
  //     try {
  //       await axios
  //         .post(`${WebsiteAPIurl}payment_response`, fdata, {
  //           headers: {
  //             Authorization: RendomTokenfetch,
  //           },
  //         })
  //         .then((response) => {
  //           // console.log("API Response:", response.data);
  //           if (response.data.Status === "1") {
  //             setPaymetSuess(true);
  //             setPaymentdata(response.data.paydata);
  //           } else if (response.data.Status === "2") {
  //             setPayFeild(true);
  //           } else {
  //             NotifyMessageNoReload(response.data.message, "danger", true);
  //             navigate("/page-not-found");
  //             setPayFeild(false);
  //             setPaymetSuess(false);
  //           }
  //         });
  //     } catch (err) {
  //       console.log(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   FetchVendorStatusData();
  // }, [RendomTokenfetch, navigate]);

  const FetchTransaction = useCallback(async () => {
    let fdata = new FormData();
    fdata.append("order_id", getLastSegment());
    setLoading(true);
    try {
      await axios
        .post(`${WebsiteAPIurl}payment_response`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          if (response.data.Status === "1") {
            setPaymetSuess(true);
            setPaymentdata(response.data.paydata);
          } else if (response.data.Status === "2") {
            setPayFeild(true);
            setPaymentdata(response.data.paydata);
          } else {
            NotifyMessageNoReload(response.data.message, "danger", true);
            navigate("/page-not-found");
            setPayFeild(false);
            setPaymetSuess(false);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, navigate]);

  useEffect(() => {
    FetchTransaction();
  }, [FetchTransaction]);

  const transaction = {
    user_email: Paymentdata?.user_email || "",
    user_name: Paymentdata?.user_name || "",
    user_number: Paymentdata?.user_number || "",
    user_address: Paymentdata?.user_address || "",
    seller_email: Paymentdata?.seller_email || "",
    seller_name: Paymentdata?.seller_name || "",
    seller_number: Paymentdata?.seller_number || "",
    seller_address: Paymentdata?.seller_address || "",
    amount: Paymentdata?.amount || 0,
    discountamount: Paymentdata?.discountamount || 0,
    totalamount: Paymentdata?.totalamount || 0,
    date: Paymentdata?.date || "",
    order_id: Paymentdata?.order_id || "",
    paid_status: Paymentdata?.paid_status || "",
    payment_mode: Paymentdata?.payment_mode || "",
    recept_no: Paymentdata?.recept_no || "",
    payu_txnid: Paymentdata?.payu_txnid || "",
  };

  const PaidType_status = (paid_type) => {
    let paid_type_status;
    let showBordersStyle;
    let showTextStyle;
    if (paid_type === "Paid") {
      paid_type_status = <span className="badge bg-success">{paid_type}</span>;
      showBordersStyle = "border-success";
      showTextStyle = "text-success";
    } else {
      paid_type_status = <span className="badge bg-danger">{paid_type}</span>;
      showBordersStyle = "border-danger";
      showTextStyle = "text-danger";
    }

    return { paid_type_status, showBordersStyle, showTextStyle };
  };

  const { paid_type_status, showBordersStyle, showTextStyle } = PaidType_status(
    transaction.paid_status
  );

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      {PaymetSuess && (
        <PaymentSuccess
          Paymentdata={transaction}
          paid_type_status={paid_type_status}
          showBordersStyle={showBordersStyle}
          showTextStyle={showTextStyle}
        />
      )}

      {PayFeild && <PaymentFeild Paymentdata={Paymentdata} />}
    </>
  );
}
